export default __webpack_public_path__ + "static/media/nimLi2.ff03c22f.webp";